const adaptString = (item: string | undefined | null) => {
  if (item == null) {
    return '';
  }
  return item.trim().toLowerCase();
};

export default adaptString;
